import { observer } from 'mobx-react-lite';
import { useResolve } from './use';
import { TOKEN_AppStore } from './AppStore';

const TONE = {
  success: 'bg-emerald-500/10 ring-emerald-500/30 text-emerald-100',
  error: 'bg-rose-500/10 ring-rose-500/30 text-rose-100',
  warn: 'bg-amber-500/10 ring-amber-500/30 text-amber-100',
  info: 'bg-neutral-800 ring-neutral-700 text-neutral-100',
} as const;

export const ToasterView = observer(function ToasterView() {
  const app = useResolve(TOKEN_AppStore);
  return (
    <div className="fixed bottom-4 right-4 z-50 flex w-[min(360px,calc(100vw-2rem))] flex-col gap-2">
      {app.toasts.map((t) => (
        <div
          key={t.id}
          className={`flex items-start gap-3 rounded-lg p-3 text-sm shadow-2xl ring-1 ${TONE[t.kind]}`}
        >
          <span className="flex-1">{t.message}</span>
          <button
            onClick={() => app.dismissToast(t.id)}
            className="text-neutral-400 hover:text-neutral-200"
          >
            close
          </button>
        </div>
      ))}
    </div>
  );
});
